import type { FC } from 'react';
import { Button, Card, Flex, Progress, Typography } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import type { KpiCardViewModel } from '../../OrganizationManagerDashboardPage.types';

const { Text } = Typography;

export interface KpiSummaryCardProps {
  card: KpiCardViewModel;
  viewDetailsLabel: string;
  onViewDetails: () => void;
}

export const KpiSummaryCard: FC<KpiSummaryCardProps> = ({
  card,
  viewDetailsLabel,
  onViewDetails,
}) => {
  return (
    <Card className="om-kpi-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={12} style={{ height: '100%' }}>
        <Text className="ds-card-label">{card.title}</Text>
        <Text className="ds-kpi-value om-kpi-card__metric">{card.metric}</Text>
        <Text type="secondary" className="om-kpi-card__description">
          {card.description}
        </Text>

        <div className="om-kpi-card__capacity">
          <Flex justify="space-between" align="center">
            <Text className="ds-small-label">{card.capacityLeft}</Text>
            {card.capacityRight ? (
              <Text className="ds-small-label">{card.capacityRight}</Text>
            ) : null}
          </Flex>
          <Progress
            percent={card.progressPercent}
            showInfo={false}
            strokeColor="var(--evimo-blue)"
            trailColor="#e8eef8"
            size={{ height: 8 }}
          />
        </div>

        <Button
          type="link"
          className="om-view-details"
          onClick={onViewDetails}
          icon={<ExportOutlined />}
          iconPosition="end"
        >
          {viewDetailsLabel}
        </Button>
      </Flex>
    </Card>
  );
};
